<template>
  <div id="ProvisionalUpgrade">
    <!-- <popup ref="popupUpgrade" type="center" :coverClose="false"> -->
    <div class="popupUpgradeBOx" v-if="newPayPop">
    
      <div class="shortTerm">
        <!-- <div class="closeOrOpen">
          <img @click="close()" alt="" src="/img/vip_plan/close.png"/>
        </div> -->
        <div class="closeOrOpen" @click="close()">
            <img src="./img/closeLoginIc.png" class="closeIconBtn" alt="">
        </div>
        <div class="closeTitle">
          <div v-if="titleNum===1" class="bigTitle">会员<span class="supmoney">专享红包</span>正在派发中....请稍后</div>
          <div v-if="titleNum===1" class="smallTitle">每人仅可成功领取一次（请务必珍惜）</div>
          <div v-if="titleNum===2&&!obtain_fail" class="bigTitle">恭喜您，成功升级为 <span>{{
              userInfo.vip_name
            }}</span></div>
          <div v-if="titleNum===2&&!obtain_fail" class="smallTitle">感谢支持，免费送支付豪礼，请笑纳
          </div>
          <div v-if="titleNum===2&&obtain_fail" class="bigTitle"><span>很遗憾，领取失败</span></div>
          <div v-if="titleNum===2&&obtain_fail" class="smallTitle">失败原因：上一张被领取的优惠券被成功使用</div>
          <div v-if="titleNum===3" class="bigTitle">专享红包<span>领取成功</span>，请尽快升级</div>
          <!-- <div v-if="titleNum===3" class="smallTitle">放弃支付将视为自动放弃（请务必珍惜）</div> -->
          <div v-if="titleNum===3" class="smallTitle">
            您已成功领取{{userInfo.vip_type==1?'200元':userInfo.vip_type==2?'150元':userInfo.vip_type==6?'80':'30'}}专享红包，仅支付
            <span class="sup_item">{{parseInt(youhuiPayDeail.upgrade_good.pay_money)-youhuiPayDeail.upgrade_good.coupon_money}}元</span>
            即可升级为<span class="sup_item">{{'永久会员'}}</span>
            再得<span class="sup_item">{{ youhuiPayDeail.upgrade_good.gift_score }}</span>积分
            </div>
        </div>
        <div class="closeCenter">
          <div v-if="titleNum===1">
            <div class="sendCoupons">
              <div>
                <img alt="" src="./img/vip_plan/loading.gif" height="32" width="32"/>
              </div>

              <div>正在为您领取优惠券.....请稍等..... <span>({{ timeNum }}S)</span></div>
            </div>
          </div>
          <div v-if="titleNum===2">
            <div class="" :class="['getCoupons',obtain_fail?'yes1':'NO_1']">
              <div class="collectFail" v-if="obtain_fail">
                <img class="img_1" src="./img/vip_plan/collectFail.png" alt="">
                <p class="p_1">很遗憾，领取失败</p>
                <p class="p_2">失败原因：上一张被领取的优惠券被成功使用</p>
                <div class="zhi_1">
                  <span>仅剩最后1次机会，手慢无</span> <img class="img_2" src="./img/vip_plan/choose_1.png" alt="">
                </div>
              </div>
              <div :class="obtain_fail?'youhuiImg fiftyOth':'youhuiImg'">
                <div class="conPoint lef"></div>
                  <div class="youhuiContent">
                    <div class="youhuiDetail">
                      <div class="youhuiLef">
                        <div class="youhuiMoney">
                          <div class="monuni">¥</div>
                          <div class="monNum">{{ youhuiPayDeail.upgrade_good.coupon_money }}</div>
                        </div>
                        <div class="youhuiTip">限购买永久会员</div>
                      </div>
                      <div class="youhuiRight">
                        <div class="youhuiTiti">付费会员专属福利</div>
                        <div class="youhuiTiList">
                          <div class="TiListItem"> 仅限一次 </div>
                          <div class="TiListItem TiListItemYel"> 历史最低 </div>
                        </div>
                        <div class="accTionText">截止日期：{{tipMsgDate}}(今日)</div>

                      </div>
                    </div>
                    <div class="youhuiLing" @click="fetchQuan">
                      <div class="lingBtn" v-html="obtain_fail?'抢':'立即<br />领取'"> </div>

                      <div class="qiang" v-if="obtain_fail">
                        <img class="qiangImg" src="./img/vip_plan/shouzhi.png" alt="">
                      </div>
                    </div>
                  </div>
                <div class="conPoint rig"></div>

                <div class="pointbox">
                  <div class="pointItem" v-for="item in 30"></div>
                </div>
              </div>
              <div class="receive" v-if="!obtain_fail">
                <div class="receive_left">
                  每人 <span class="towNum">2</span> 次领取机会，共计 <span v-for="index in peopleNum">{{ index }}</span>
                  位用户已成功领取并使用
                </div>
                <!-- <div> -->
                  <img alt="" class="youhuiGuid" src="./img/vip_plan/choose.png"/>
                <!-- </div> -->
              </div>
            </div>
          </div>

          <div class="centerRight" v-if="titleNum===3">
            <!-- <div class="titleF">
              <div>
                您已成功领取{{ youhuiPayDeail.upgrade_good.coupon_money }}元专属优惠券
              </div>
              <div>
                仅再支付 <span>{{ parseInt(youhuiPayDeail.upgrade_good.pay_money) - youhuiPayDeail.upgrade_good.coupon_money }} 元</span> 即可升级为<span>永久会员</span><br/>再得<span>{{ youhuiPayDeail.upgrade_good.gift_score }}</span>积分 ← 超级划算
              </div>
            </div> -->
            <div class="three_bot">
              <div class="centerLeft" v-if="titleNum===3">
                  <div class="warnung">
                    <div class="jiaobiao">
                      <span class="jiaobiaoText">
                        活动即将结束
                      </span>
                    </div>
                    永久会员专享红包有效期:<div class="warnungTime"><span class="warnungTimeText">{{ formattedTime }}</span> 结束</div>
                    未完成支付升级，视为自动放弃！
                  </div>
                                  <div>

                  <div class="statistics">
                    <div class="moneyBig">199元</div>
                    <div class="moneySmall">{{ parseInt(youhuiPayDeail.upgrade_good.pay_money) - youhuiPayDeail.upgrade_good.coupon_money }}</div>
                    <img alt="" class="moneySmallImg" style="width: 90%;height:60px;margin-left: 5%;" src="./img/vip_plan/0.png" />
                    <div class="statistics_bot">
                      <div>
                        优惠{{youhuiPayDeail.upgrade_good.coupon_money}}元 <span>（历史最低）</span>
                      </div>
                      <div>
                        优惠100元
                      </div>
                    </div>
                  </div>

                </div>
                  <div class="remind" @click="toPay">
                    <div class="toPay">去支付</div>
                  </div>
                  <div class="payType">
                  <div class="payTypeLeft">支付方式：</div>
                    <div class="payItem">
                      <div :class="payHow==1?'paySele wei':'paySele'" @click="changePay(1)">
                        <div class="payPoint weiPo" v-show="payHow==1"></div>
                      </div>
                      <div class="payName weiText">微信支付</div>
                    </div>
                    <div class="payItem payItemBao" v-show='!isWeixin'>
                      <div :class="payHow==2?'paySele bao':'paySele'" @click="changePay(2)">
                        <div class="payPoint baoPo" v-show="payHow==2"></div>
                      </div>
                      <div class="payName baoText">支付宝支付</div>
                    </div>


                  </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    
    </div>


    <!-- </popup> -->
  </div>

</template>

<script type="text/ecmascript-6">
export default{
  data(){
    return{
      titleNum:1,
      timeNum:5,
      timer:null,
      peopleNum:[8,7,3,9,5],
      tipMsgDate:'',
      endData:'',
      uniq_key:'',
      timerout:false,
      pay_time:0,
      code_url:'',
      closePrompt:false,
      pay_money:'',
      site_name:'',
      gift_score:'',
      popupUpgrade:null,
      isWeixin:false,
      payHow:1,
      obtain_fail:false,
      remainingTime:10*60*1000,
      timerDown:null
    }
  },
  mounted(){
    this.checkSystem()
    this.getTimes()
    this.startCountdown()
    if(!localStorage.getItem('formattedTime')){
      localStorage.setItem('formattedTime',Date.now())
    }
    if(localStorage.getItem('zz_vipForeverQuan')){
      this.titleNum = 3
    }else{
      this.fetchQuan()
    }
  },
  computed:{
    newPayPop() {
      return this.$store.state.newPayPop
    },
    youhuiPayDeail() {
      return this.$store.state.youhuiPayDeail
    },
    userInfo(){
      return this.$store.state.userInfo;
    },
    formattedTime(){
        const minutes = Math.floor(this.remainingTime / (60 * 1000));
        const seconds = Math.floor((this.remainingTime % (60 * 1000)) / 1000);
        const milliseconds = this.remainingTime % 1000;
        const padZero = (num) => num.toString().padStart(2, '0');
  
        return `${padZero(minutes)}:${padZero(seconds)}:${padZero(milliseconds).slice(0, 2)}`;
    }

  },
  methods:{
    startCountdown() {
      if (this.isRunning) return;
      this.isRunning = true;

      // 每10毫秒更新一次（流畅版，可改为100毫秒降低性能消耗）
      this.timerDown = setInterval(() => {
        this.remainingTime -= 10;
        if (this.remainingTime <= 0) {
          clearInterval(this.timerDown);
          this.remainingTime = 0;
          this.isRunning = false;
          localStorage.removeItem('isToUpVip')
          this.$store.commit('setIsYouhuiPopshow', false)
          this.$store.commit('setType',1)
          localStorage.removeItem('formattedTime')
        }
      }, 10);
    },
    handelCoupon() {
      // 缓存用户领取优惠时间

      // payKeStore.showVipTime(true)
      this.$store.commit('showVipTime', true)
      localStorage.setItem('vip_time', Date.now())
      localStorage.setItem('zz_vipForeverQuan',1)
    },
    close() {
      this.handelCoupon()
      if (this.closePrompt) {
        // popupUpgrade.value.close();
        // payKeStore.kekePopSet(false)
        localStorage.setItem('payTip',JSON.stringify({time: Date.now()}))
        this.closePrompt = false
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
        this.$store.commit('setNewPayPop',false)
        // if(!localStorage.getItem('ling2')){
        //   //显示红包翻倍弹窗
        //   this.$store.commit('setSecYouh', true)
        //   localStorage.removeItem('zz_vipForeverQuan')
        //   this.titleNum = 1
        // }

      } else {
        this.$confirm(
          this.titleNum === 2 ? '您还有大额优惠券未领取，您确定要放弃吗？' : this.titleNum === 1 ? '系统正在为您派发优惠券，您确定要放弃吗？' : "永久会员价格（历史最低）的活动将于" + this.tipMsgDate + "日截止（今天是最后一天），您确定要放弃吗？",
          '提示', {
          showCancelButton: false, // 是否显示取消按钮
          confirmButtonText: '好的，我已知晓',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.obtain_fail = true
          if (this.titleNum === 2) {
            this.titleNum = 1
            this.startTimer()
          } else if (this.titleNum === 1) {
            this.titleNum = 3
            this.clearTimer()
          } else {
            this.closePrompt = this.closePrompt? false : true
            // newPayPop
            // this.$store.commit('setNewPayPop',false)

          }
        }).catch(() => {
        });
      }
    },
    getTimes() {
  const now = new Date();
  const year = now.getFullYear(); // 获取当前年份
  const month = now.getMonth() + 1; // 获取当前月份，注意getMonth()返回的是0-11，所以需要加1
  const day = now.getDate(); // 获取当前日期
  this.tipMsgDate = year + '-' + month + '-' + day;
  this.endDate = (year + 100) + '-' + month + '-' + day;
},
    setNewShow(data){
      this.titleNum = 3
    },
    toPay(){
        let pay_from = "h5pay"
        let pay_source = "wap"
        if (this.isWxEnv) {
          pay_source = "wapwx"
        }
        if (!this.isWxEnv && this.payHow == 1) {
          pay_from = "h5wxpay"
        }
        let data = {
        "appid": APP_ID,
        "pay_flat":this.payHow,
        "pay_source": this.isWxEnv? pay_source:"wap",
        "pay_from": this.isWxEnv? pay_from:"h5pay",
        "is_upgrade": 1,
        "pro_type": 0,
        "upgrade_id": `${this.userInfo.vip_type}-1`,
        "vip_id":this.youhuiPayDeail.vip_id==1?'level_1':'level_2',
        "vip_type":5
      }
      this.$http.post('/front/aivideo/pay/chongzhi/',data).then(res=>{
        if (res.status == 200) {
          let code_url = res.data.pay_url;
          // uniq_key = res.data.uniq_key;
          // location.href = code_url;
          this.chongzhiSta(res.data.uniq_key)
          let userAgent = navigator.userAgent;
          let isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1;
          let isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

          localStorage.setItem('_goPay',true)

          if (isAndroid) {
            // 执行Android相关的代码
            window.open(res.data.pay_url);
          }

          if (isIOS) {
            // 执行iOS相关的代码
            // alert('ios')
            var winRef = window.open(" ","_self")
            winRef.location = res.data.pay_url
          }
          // window.open(res.data.pay_url)
        }
      })
    },
    chongzhiSta(data){
      this.$http.get('/pay/order/status/',{
                        params:{
                    uniq_key:data
                }
      }).then(res=>{
            console.log(res);
            if(res.data.code){
              this.$http.get(`/front/user/profile/`).then(res => {
                clearInterval(this.chongzhiTime)
                if (res.status == 200) {
                  this.$store.commit('setUserInfo', res.data)
                  localStorage.removeItem('isTodyYouh')
                  this.$store.commit('setVipCongratulationsShow',true)
                  localStorage.removeItem('paynum')
                  localStorage.removeItem('ling1')
                  localStorage.removeItem('ling2')
                  this.$store.commit('setIsYouhuiPopshow',false)
                }
              })
            }else{
                this.chongzhiTime = setInterval(() => {
                    this.chongzhiStaFn(data)
                }, 3000);
            }
            
        })
    },
    chongzhiStaFn(data){
            this.$http.get('/pay/order/status/',{
                        params:{
                    uniq_key:data
                }
      }).then(res=>{
            if(res.data.code){
              this.$http.get(`/front/user/profile/`).then(res => {
                        clearInterval(this.chongzhiTime)
                if (res.status == 200) {
                  this.$store.commit('setUserInfo', res.data)
                  localStorage.removeItem('isTodyYouh')
                  this.$store.commit('set_type',0)
                  this.$store.commit('setVipCongratulationsShow',true)
                  localStorage.removeItem('paynum')
                  localStorage.removeItem('ling1')
                  localStorage.removeItem('ling2')
                  this.$store.commit('setIsYouhuiPopshow',false)
                }
              })
            }
        })
    },
    changePay(data){
      this.payHow = data
    },
    fetchQuan() {
      //  领取优惠

      // if (obtain_fail.value == false) {
      //   obtain_fail.value = !obtain_fail.value
      // } else {
      this.titleNum = 1
      this.startTimer()

      this.handelCoupon()
      // this.fetchPayQrCode()
      // }

    },
    fetchPayQrCode() {
      // 获取支付二维码
      this.$http.get('/front/aimj/pay/today_order/').then(res => {
        this.$store.commit('setYouhuiPayDeail',res.data)
      })
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.timeNum--;
        if (this.timeNum == 0) {
          this.clearTimer()
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      if (!this.obtain_fail) {
        console.log('clearTimer111')
        this.obtain_fail = !this.obtain_fail
        this.titleNum = 3
      } else {
        console.log('clearTimer222')
        this.titleNum = 3
        // fetchPayQrCode()
      }

      this.timeNum = 5

    },
    checkSystem(){
      var ua = navigator.userAgent.toLowerCase();
      if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
        this.isWeixin = true;
      } else {
        this.isWeixin = false;
      }
    }
  },
  watch:{
    newPayPop(newVal){
      if(newVal&&!localStorage.getItem('zz_vipForeverQuan')){
        this.fetchQuan()
      }
    }
  }

}
</script>
<style scoped lang="scss">
#ProvisionalUpgrade{
  z-index: 9999;
  display: flex;
}
.popupUpgradeBOx{
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: rgba(0,0,0,.5);
  display: flex;
  align-items: center;
  justify-content: center;
  // flex-shrink: 0;
}
.shortTerm {
  padding: 10px 20px;
  // width: 900px;
  width:calc(100vw - 20px);
  // height: 380px;

  position: relative;
  background-image: url("./img/vip_plan/011.png");
  background-size: 100% 100%;
  border-radius: 13px;
  display: flex;
  flex-direction: column;
  // flex-shrink: 0;
  // overflow: hidden;

  .closeOrOpen {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #fff;
    position: absolute;
    bottom: -60px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 20px;
      cursor: pointer;
    }
  }

  .closeTitle {
    padding-bottom: 10px;
    // margin-top: 35px;

    .bigTitle {
      font-size: 20px;
      font-weight: 700;
      color: #4a3304;
      // margin-bottom: 15px;
      .supmoney{
        color: #f64834;
      }

      span {
        color: #f64834;
      }
    }

    .smallTitle {
      font-size: 16px;
      color: #fc631e;
      //margin-bottom: 20px;
      margin-top: 8px;
      .sup_item{
        background: #fff;
        font-size: 12px;
        padding: 2px 5px;
        border-radius: 4px;
        margin: 0 5px;
      }
    }
  }

  .closeCenter {
    display: flex;
    align-items: center;
    justify-content: center;
    // margin-top: 10px;
    flex-shrink: 0;
    background: #fff;
    width: calc(100% + 20px);
    margin-left: -10px;
    border-radius: 8px;

    .centerLeft {
      // width: 560px;
      // padding: 10px 60px 0 20px;

      // .warnung {
      //   width: 90%;
      //   font-size: 12px;
      //   color: #bf0404;
      //   background-color: #ffe0cf;
      //   padding: 10px;
      //   border-radius: 2px;
      //   // position: relative;
      //   white-space: nowrap;
      //   text-align: center;
      //   margin: 0 auto;
      //   margin-bottom: 15px;
      //   // margin-bottom: 10px;
      //   //img{
      //   //  position: absolute;
      //   //  top: 0;
      //   //  right: 0;
      //   //  height: 25px;
      //   //}
      // }
      .warnung {
        width: 90%;
        font-size: 14px;
        color: #bf0404;
        background-color: #ffe0cf;
        padding: 10px;
        border-radius: 2px;
        // white-space: nowrap;
        text-align: center;
        margin: 0 auto;
        margin-bottom: 30px;
        margin-top: 15px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        line-height: 28px;
        position: relative;
        box-sizing: border-box;
        .jiaobiao {
          height: 40px;
          width: 100px;
          position: absolute;
          top: -10px;
          right: -5px;
          background-image: url("./img/vip_plan/jiaobiao.png");
          background-size: contain;
          background-repeat: no-repeat;
          color: white;
          font-size: 14px;
          // padding: 4rpx 0 0 16rpx;
          padding-left: 5px;
          .jiaobiaoText{
            position: absolute;
            top: -3px;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
          }
        }
        .warnungTime{
          width: 170rpx;
          white-space: nowrap;
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          .warnungTimeText{
            width: 58px;
          }
        }
      }

      .statistics {

        position: relative;

        .moneyBig {
          position: absolute;
          top: -13px;
          right: 16%;
          font-size: 14px;
          color: #999;
          // background: #000;
        }

        .moneySmall {
          position: absolute;
          top: 20px;
          left: 21%;
          font-size: 12px;
          font-weight: 600;
          color: white;
          width: 100%;

          .moneySmallImg{

          }
        }
        .moneySmallOther{
            top: 20px;
            left: 20.5%;
        }

        .statistics_bot {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          padding: 9px 50px 0 30px;
          // margin-bottom: 40px;
          color: #999;
          margin-bottom: 20px;

          span {
            color: #cf4040;

          }
        }

      }
      .payType{
        display: flex;
        align-items: center;
        // justify-content: center;
        width: 90%;
        margin: 20px auto;
        white-space: nowrap;
        .payTypeLeft{
          color: #000;
        }
        .payItem{
          color: #ccc;
          display: flex;
          align-items: center;
          font-size: 14px;
          .paySele{
            width: 17px;
            height: 17px;
            border: 1px solid #ccc;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            .payPoint{
              width: 13px;
              height: 13px;
              border-radius: 50%;
            }
            .weiPo{
              background: #49b339;
            }
            .baoPo{
              background: #0099e6;
            }
          }
          .payName{
            margin-left: 10px;
          }
          .weiText{
            color: #49b339;
          }
          .baoText{
            color: #0099e6;
          }
          .wei{
            border: 1px solid #49b339;
          }
          .bao{
            border: 1px solid #0099e6; 
          }
        }
        .payItemBao{
          //margin-left: 30px;
          margin-right: 20px;
        }
      }

      .remind {
        width: 90%;
        height: 50px;
        font-size: 12px;
        background-color: #f64834;
        color: #999;
        border-radius: 5px;
        // text-align: center;
        // line-height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        // margin-top: 5px;
        margin: 10px auto;
        // overflow: hidden;
        .toPay{
          font-size: 18px;
          color: #fff;
          // margin: 5px;
        }
      }


    }

    .centerRight {
      width: 100%;
      // padding: 10px 60px;

      //padding-top: 50px;
      .titleF {
        color: #000000;
        font-size: 16px;
        text-align: center;
        
        margin-top: 30px;
        line-height: 40px;

        div {
          // margin: 20px 0;
        }

        span {
          color: #ba0000;
          margin: 0 10px;
          font-weight: 700;

        }
      }

      .three_bot {
        //width: 300px;
        display: flex;
        justify-content: space-between;

        .three_botLef {
          // width: 200px;
          margin: 0 10px 0 50px;
        }
      }

      .qrCode {
        // width: 180px;
        // height: 180px;
        margin: 0 auto;
        margin-bottom: 25px;
        margin-top: 13px;
        display: flex;
        align-items: center;
        border: 1px solid #e8e8e8;
        position: relative;

        .qrCode_left {
          height: 100%;
          width: 25px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: absolute;
          top: 0;
          left: 0;

          .topLeft {
            width: 25px;
            height: 25px;
            border-top: 2px solid #e85555;
            border-left: 2px solid #e85555;
          }

          .bottomLeft {
            width: 25px;
            height: 25px;
            border-bottom: 2px solid #e85555;
            border-left: 2px solid #e85555;
          }
        }

        .qrCode_center {
          // width: 170px;
          // height: 170px;
          position: relative;
          margin: 0 auto;

          .timeout {
            display: block;
            width: 100% !important;
            height: 100% !important;
          }

          .time_out_cover {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 5;
            cursor: pointer;
            background-color: rgba(0, 0, 0, 0.58);
            color: #fff;
            font-size: 14px;
            z-index: 10;

            &:hover {
              font-size: 15px;
              font-weight: bold;
            }

            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .qrCode_right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          width: 25px;
          position: absolute;
          top: 0;
          right: 0;

          .topRight {
            width: 25px;
            height: 25px;
            border-top: 2px solid #e85555;
            border-right: 2px solid #e85555;
          }

          .bottomRight {
            width: 25px;
            height: 25px;
            border-bottom: 2px solid #e85555;
            border-right: 2px solid #e85555;
          }
        }
      }

      .script {
        display: flex;
        flex-direction: column;
        align-items: center;

        .script_money {
          color: #000000;
          font-size: 16px;
          font-weight: 700;

          span {
            color: #bd0000;
          }
        }

        .script_prompt {
          color: #000000;
          font-size: 12px;
          margin: 25px 0 0 0;
          display: flex;

          img {
            width: 15px;
            height: 15px;
            margin: 0 5px;
          }
        }


      }
    }

    // 优惠券等待
    .sendCoupons {
      color: #000000;
      // width: 890px;
      height: 18.5rem;
      //background-color: aquamarine;
      // margin-top: 90px;
      // margin-top: 3rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span {
        color: #cb3131;
      }
    }

    .sendCoupons div:first-child {
      margin-bottom: 30px;
    }

    //  领取优惠券
    .getCoupons {
      // width: 850px;
      // height: 440px;
      //background-color: aquamarine;
      display: flex;
      flex-direction: column;
      // align-items: center;
      //justify-content: center;
      padding: 30px 0 30px 0;
      &.yes1 {
        //justify-content: center;
        // padding-top: 15px;
      }

      &.NO_1 {
        justify-content: center;
      }

      .collectFail {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 20px;

        .img_1 {
          width: 60px;
          font-size: 0;
        }

        .p_1 {
          font-size: 16px;
          font-weight: 700;
          color: #000000;
          margin: 10px 0;
        }

        .p_2 {
          font-size: 14px;
          color: #bbbbbb;
        }

        .zhi_1 {
          color: #dc433d;
          display: flex;
          margin: 50px 0 10px;
          position: relative;
          //padding-left: 200px;
          z-index: 1;

          span {
            //padding: 12px 10px 0 0;
          }

          .img_2 {
            //display: none;
            width: 47px;
            position: absolute;
            right: -55px;
            top: -2px;
          }
        }

      }

      .youhuiImg{
        width: calc(100% - 50px);
        // width: 19rem;
        // height: 150px;
        height: 100px;
        padding-bottom: 5px;
        background-color: #fad002;
        border-radius: 4px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        // flex-shrink: 0;
        margin: 0 auto;
        margin-top: 30px;
        box-sizing: border-box;
        .conPoint{
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 14px;
          height: 14px;
          background: #fff;
          border-radius: 50%;

        }
        .pointbox{
          position: absolute;
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          .pointItem{
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #fff;
          }
        }
        .lef{
            left: -8px;
          }
          .rig{
            right: -8px;
          }

          .youhuiContent{
            width: calc(100% - 15px);
            height: calc(100% - 20px);
            // background: #ccc;
            display: flex;
            // justify-content: space-around;
            // flex-shrink: 0;
            .youhuiDetail{
              // width: 90%;
              // width: calc(19rem - 20px);
              width: 14rem;
              height: 100%;
              background: #fff;
              border-radius: 4px;
              padding: 5px 0;
              padding-left: 5px;
              display: flex;
              // overflow: hidden;
              .youhuiLef{
                // width: 38%;
                width: 5rem;
                height: 100%;
                padding-right: 10px;
                border-right: 1px dotted #f8b274;
                // margin-left: 10px;
                padding-left: 0.2rem;
                .youhuiMoney{
                  // background: #000;
                  display: flex;
                  align-items: first baseline;
                  color: #dc433d;
                  height: 70%;
                  // padding-top: 10px;
                  // line-height: 0;
                  // line-height: 30px;

                  .monuni{
                    font-size: 18px;
                    font-weight: 600;
                  }
                  .monNum{
                    // font-size: 40px;
                    font-size: 2.2rem;
                    font-weight: 700;
                  }

                }
                .youhuiTip{
                  color: #bd9576;
                  font-size: 0.65rem;
                  white-space: nowrap;
                }
              }
              .youhuiRight{
                // flex: 1;
                display: flex;
                flex-direction: column;
                // align-items: center;
                justify-content: space-between;
                // padding: 0 15px;
                padding: 0 0.5rem;
                .youhuiTiti{
                  color: #000;
                  font-size: 14px;
                  font-weight: 600;
                  white-space: nowrap;
                }
                .youhuiTiList{
                  display: flex;
                  // justify-content: space-between;
                  margin-top: 5px;
                  .TiListItem{
                   width: 56px;
                   height: 20px;
                   border-radius: 3px;
                   background: #a2673b;
                   color: #fff;
                    font-size: 11px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                  .TiListItemYel{
                    background: #fad002;
                    margin-left: 5px;
                  }

                }
                .accTionText{
                  color: #9f6336;
                  font-size: 10px;
                  margin-top: 5px;
                  white-space: nowrap;
                }
              }
            }
            .youhuiLing{
              // flex: 1;
              background: transparent;
              display: flex;
              align-items: center;
              justify-content: center;
              // margin-right: 10px;
              position: relative;
              .lingBtn{
                width: 55px;
                height: 55px;
                border-radius: 50%;
                background: #dc433d;
                margin-left: 8px;
                margin-right: 18px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                // font-size: 14px;
              }
              .qiang {
          width: 41.7px;
          height: 29px;
          position: absolute;
          bottom: 0px;
          right: 20px;
          animation: finger-click 1s ease-in-out infinite alternate; /* 循环动画 */
          .qiangImg{
            font-size: 0;
            width: 100%;
            height: 100%;
          }

          @keyframes finger-click {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
            100% {
              transform: scale(1);
            }
          }

        }
            }
          }
      }

      .fifty {
        cursor: pointer;
        // width: 600px;
        // height: 85px;
        //margin-bottom: 20px;
        // width: calc(100vw - 80px);
        width: calc(100% - 20px);
        position: relative;
        background-size: cover;
        background-repeat: no-repeat;
        // background-attachment: fixed;
        font-size: 10px;
        display: flex;
        // flex-shrink: 0;
        margin: 0 auto;
        padding: 4px 2px;
        //background-color: aquamarine;
        // padding: 20px 28px;
        // justify-content: space-around;
        margin-top: 25px;
        .fifIMG{
          width: 100%;
          height: 90px;
        }
        &.bg_fifty1 {
          background-image: url("./img/vip_plan/1.png");
        }

        &.bg_fifty2 {
          background-image: url("./img/vip_plan/3.png");
        }

        .fiftyLeft {
          // width: 190px;
          // margin-right: 10px;
          white-space: nowrap;
          // margin-left: 25px;
          display: flex;
          margin-left: 18px;
          margin-right: 12px;
          padding-top: 50px;
          color: #cdab93;
        
          
        }

        .fiftyRight {
          // padding: 15px 0 0 0;
          width: 150px;
          padding:10px;
          color: #9f6336;
          // background: #ccc;
          // margin-right: 20px;

          .rightOne {
            font-size: 12px;
            font-weight: 700;
            margin-bottom: 5px;
          }

          .rightTwo {
            margin-top: 5px;
          }

          .rightThree {
            margin: 5px 0;
            color: white;

            span {
              padding: 3px 5px;
              border-radius: 2px;
              overflow: hidden;
            }

            .one {
              background-color: #9f6336;
            }

            .two {
              background-color: #dc433d;
              margin: 0 10px;
            }

            .three {
              background-color: #fad002;
              margin-left: 10px;
            }
          }
        }

        .qiang {
          width: 15px;
          height: 15px;
          position: absolute;
          bottom: 0;
          right: 0;
          animation: finger-click 1s ease-in-out infinite alternate; /* 循环动画 */

          @keyframes finger-click {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
            100% {
              transform: scale(1);
            }
          }

        }
      }
      .fiftyOth{
        // width: calc(100% - 10px);
        width: calc(100% - 60px);
        margin-top: 5px;
        // padding: 3px;
        // margin-left: px;
        .lingBtn{
          font-size: 30px;
          margin-left: 5px !important;
          margin-right: 30px !important;
        }
      }

      .receive {
        display: flex;
        align-items: flex-end;
        margin: 0 auto;
        margin-top: 80px;
        position: relative;
        width: calc(100% - 50px);


        .youhuiGuid{
          position: absolute;
          right: 10px;
          // transform: translateX(0%);
          top: -70px;
          width: 60px;
          height: 60px;

        }

        .receive_left {
          color: #000000;
          //margin-left: 200px;
          //margin-right: 110px;
          font-size: 14px;
          line-height: 30px;
        }

        .towNum {
          padding: 0 3px;
          color: white;
          background-color: #dc433d;
          margin: 2px;
          border-radius: 2px;
          overflow: hidden;
        }

        span {
          padding: 0 3px;
          color: white;
          background-color: #454545;
          margin: 2px;
          border-radius: 2px;
          overflow: hidden;
        }

        img {
          width: 100px;
          margin-left: 10px;
          margin-bottom: 5px;
        }
      }
    }

  }
}
</style>